<template>
  <DMModal @modal-close="reset" ref="dm" name="join" :width="550">
    <div slot-scope="{ params }">
      <template v-if="params.url !== null">
        <input
          v-if="params.protected"
          class="text-input placeholder-gray-500 placeholder-opacity-50 mb-3 text-center"
          type="text"
          v-model="code"
          placeholder="Enter Password"
          name="edu-code"
        />
        <button
          :disabled="params.protected && code !== params.code"
          :class="{
            'w-full bg-white-50 py-2 rounded-full': true,
            'opacity-50': params.protected && code !== params.code,
            'hover:bg-dm': !(params.protected && code !== params.code),
          }"
          @click.prevent="() => openLink(params.url)"
        >
          {{ params.text }}
        </button>
      </template>
    </div>
  </DMModal>
</template>

<script>
import DMModal from '@components/DMModal';

export default {
  name: 'LegalModal',
  components: { DMModal },

  data() {
    return {
      code: null,
    };
  },

  methods: {
    reset() {
      this.code = null;
    },
    openLink(url) {
      this.$modal.hide('join');
      this.goTo(url);
    },
  },
};
</script>

<style scoped></style>
